import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import styles from './EmailForm.module.css';

class EmailForm extends Component {
  handleBack = () => {
    this.props.onBack(true);
  };

  render() {
    const { emails, email, signupToken, onChange, handleSubmit } = this.props;

    return (
      <div className="boxed-container">
        <p className="invite">Please enter your email address</p>
        <form className="form-fixed-width-small form-animated" onSubmit={handleSubmit}>
          <div className="margin-bottom-large">
            <input
              id="av_email"
              name="av_email"
              placeholder="Email"
              type="email"
              required
              autoFocus
              value={email}
              onChange={onChange}
            />
            {signupToken &&
            (<div className={styles.helpSignup}>
              <Link className={styles.link} to={`/session/signup?sign_up_token=${signupToken}`}>
                Need an account?
              </Link>
            </div>)}
          </div>
          <div>
            {emails && emails.length > 0 && (
              <input className="btn" type="button" onClick={this.handleBack} value="BACK" />
            )}
            <input className="btn" type="submit" value="NEXT" />
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(EmailForm);
